import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { Input, Button, ErrorSummary } from 'govuk-react-jsx';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  getPMCRegistrationNumber,
  setPMCRegistrationNumber,
  setPMCData,
} from '../../features/pmc/pmcJourneySlice';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import { checkValidCompanyRegistration } from '../../regex/regex';
import { getCompanyData } from '../../firebase';
import useTitle from '../../hooks/useTitle';

const CompanyRegistrationNumber = () => {
  const [errorList, setErrorList] = useState([]);
  const companyRegistrationNumberRedux = useSelector(getPMCRegistrationNumber);
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;

  useTitle(
    'pmcClientReg.CompanyRegistrationNumber.s10',
    "Enter your client's company registration number  - OZEV Electric Vehicle Chargepoint Grant - GOV.UK"
  );
  const dispatch = useDispatch();
  const history = useHistory();
  const [errorMsg, setErrorMsg] = useState('');

  const handleCompanyRegistration = (event) => {
    dispatch(setPMCRegistrationNumber(event.target.value));
  };

  const errorMessage = copyProvider.getCopy(
    'pmcClientReg.CompanyRegistrationNumber.s1',
    'Enter a valid Company Registration number that consists of 8 characters and can contain letters and numbers'
  );

  const errorNotValidAPI = copyProvider.getCopy(
    'pmcClientReg.CompanyRegistrationNumber.s2',
    'Entered Company Registration number not recognised'
  );

  const errorAlreadyExistsAPI = copyProvider.getCopy(
    'pmcClientReg.CompanyRegistrationNumber.s9',
    'This number is already in use with another account'
  );

  const showError = {
    children: errorMessage,
  };

  const showErrorNotValidAPI = {
    children: errorNotValidAPI,
  };

  const showErrorAlreadyExistsAPI = {
    children: errorAlreadyExistsAPI,
  };

  const handleBtnClick = () => {
    if (checkValidCompanyRegistration.test(companyRegistrationNumberRedux)) {
      setErrorMsg(null);

      getCompanyData({ companyRegNumber: companyRegistrationNumberRedux })
        .then((response) => {
          const { data } = response;

          dispatch(setPMCData(data));

          history.push('/pmcClientReg/confirm-business-details');
        })
        .catch((error) => {
          if (error.code === 'functions/already-exists') {
            setErrorMsg(showErrorAlreadyExistsAPI);
            setErrorList([
              {
                ...showErrorAlreadyExistsAPI,
                href: '#companyRegistrationNumber',
              },
            ]);
          } else {
            setErrorMsg(showErrorNotValidAPI);
            setErrorList([
              { ...showErrorNotValidAPI, href: '#companyRegistrationNumber' },
            ]);
          }
        });
    } else if (
      !checkValidCompanyRegistration.test(companyRegistrationNumberRedux)
    ) {
      setErrorMsg(showError);
      setErrorList([{ ...showError, href: '#companyRegistrationNumber' }]);
    }
  };

  const pageModel = (
    <>
      {errorList?.length > 0 && (
        <ErrorSummary
          errorList={errorList}
          titleChildren={copyProvider.getCopy(
            'Common.error-summery',
            'There is a problem'
          )}
        />
      )}
      <div className="govuk-form-group">
        <h1 className="govuk-heading-xl">
          {copyProvider.getCopy(
            'pmcClientReg.CompanyRegistrationNumber.s3',
            "Enter your client's company registration number"
          )}
        </h1>
        <p className="govuk-body">
          {copyProvider.getCopy(
            'pmcClientReg.CompanyRegistrationNumber.s4',
            "We will use this to confirm your client's business details.This is the best number to use for a fast registration."
          )}
        </p>
        <div className="govuk-form-group">
          <div className="govuk-body">
            <Input
              errorMessage={errorMsg || null}
              hint={{
                children: copyProvider.getCopy(
                  'pmcClientReg.CompanyRegistrationNumber.s6',
                  'Companies House provides this number when a company first registers.'
                ),
              }}
              label={{
                children: copyProvider.getCopy(
                  'pmcClientReg.CompanyRegistrationNumber.s5',
                  'Company registration number'
                ),
              }}
              id="companyRegistrationNumber"
              className="govuk-input govuk-!-width-two-thirds"
              name="companyRegistration"
              type="text"
              value={companyRegistrationNumberRedux}
              onChange={(event) => handleCompanyRegistration(event)}
            />
          </div>
        </div>
      </div>
      <div className="govuk-body govuk-!-font-size-19 govuk-!-padding-bottom-6">
        <Link className="govuk-link " to="/pmcClientReg/company-VAT-number">
          {copyProvider.getCopy(
            'pmcClientReg.CompanyRegistrationNumber.s7',
            "My client doesn't have a company registration number"
          )}
        </Link>
      </div>

      <Button className="govuk-button" onClick={handleBtnClick}>
        {copyProvider.getCopy(
          'pmcClientReg.CompanyRegistrationNumber.s8',
          'Continue'
        )}
      </Button>
    </>
  );

  return pageModel;
};

export default CompanyRegistrationNumber;
